// extracted by mini-css-extract-plugin
export default {"downloadButton":"styles_downloadButton__KHDu5"};